var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("供应点管理")]),
              _c("el-breadcrumb-item", [_vm._v("交易管理")]),
              _c("el-breadcrumb-item", [_vm._v("交易查询")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            {
              ref: "listParamsForm",
              attrs: { model: _vm.listParams, "label-width": "100px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号：", prop: "orderNo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.listParams.orderNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "orderNo", $$v)
                              },
                              expression: "listParams.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态：", prop: "orderStatus" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "", size: "small" },
                              model: {
                                value: _vm.listParams.orderStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "orderStatus", $$v)
                                },
                                expression: "listParams.orderStatus",
                              },
                            },
                            _vm._l(_vm.orderStatusList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "电话号码：", prop: "buyerMobile" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入电话号码",
                            },
                            model: {
                              value: _vm.listParams.buyerMobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "buyerMobile", $$v)
                              },
                              expression: "listParams.buyerMobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "领货日期：", prop: "timeInterval" },
                        },
                        [
                          _c("date-picker-group", {
                            model: {
                              value: _vm.listParams.timeInterval,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "timeInterval", $$v)
                              },
                              expression: "listParams.timeInterval",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "20px" },
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("listParamsForm")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              ref: "table",
              attrs: { slot: "content", data: _vm.tableData, border: "" },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  prop: "orderNo",
                  align: "center",
                  label: "订单编号",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.orderNo
                          ? _c("div", [
                              scope.row.orderNo.length > 10
                                ? _c(
                                    "div",
                                    [
                                      _c("el-popover", {
                                        ref: "popover1",
                                        attrs: {
                                          placement: "top-start",
                                          width: "200",
                                          trigger: "hover",
                                          content: scope.row.orderNo,
                                        },
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "popover",
                                              rawName: "v-popover:popover1",
                                              arg: "popover1",
                                            },
                                          ],
                                          staticStyle: { color: "#606266" },
                                          attrs: { type: "text" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatLimitLength")(
                                                scope.row.orderNo
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(_vm._s(scope.row.orderNo)),
                                  ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  prop: "buyerMobile",
                  align: "center",
                  label: "买家信息",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  align: "center",
                  label: "商品定金",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "levelDiscountAmount",
                  align: "center",
                  label: "折扣金额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.levelDiscountAmount
                                ? row.levelDiscountAmount
                                : 0
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "补差/退款" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              (row.paymentAmount * 1000 -
                                row.amountTotal * 1000) /
                                1000
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyDate",
                  align: "center",
                  width: "200",
                  label: "领货日期",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStatusDisplay",
                  align: "center",
                  label: "订单状态",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "paymentType",
                  align: "center",
                  label: "支付方式",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.linkToDetailPage(scope.row.orderId)
                              },
                            },
                          },
                          [_vm._v(" 详情 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("DialogRefund", {
        attrs: {
          dialogVisible: _vm.dialogVisibleRefund,
          orderItem: _vm.refundItem,
        },
        on: {
          "update:dialogVisible": function ($event) {
            _vm.dialogVisibleRefund = $event
          },
          "update:dialog-visible": function ($event) {
            _vm.dialogVisibleRefund = $event
          },
          success: _vm.loadTableData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }